export const TAROT_TAG_ID = 202

export const FORTUNE_INFO = {
  id201: {
    tagId: 201,
    label: '西洋占星術',
    description: '星の動き・配置から、性質や運勢などを占うものです。普段「○○座です」というのは、西洋占星術では太陽星座を差します。月・水星・金星など、他の星の配置も見ることで、更にさまざまな側面から占います。',
    thumbnail: '/static/img/fortunes/icons/icon_senseijutsu.svg'
  },
  id202: {
    tagId: 202,
    label: 'タロット',
    description: 'タロットカードをシャッフルし、その質問に応じた方法で展開していくことで意味を読み解いていきます。基本的に大アルカナ22枚・小アルカナ56枚、計78枚のセットから成り立っています。',
    thumbnail: '/static/img/fortunes/icons/icon_tarot.svg'
  },
  id203: {
    tagId: 203,
    label: '四柱推命',
    description: '陰陽五行説を元にして、古代中国で生まれた占術の1つ。生年月日、誕生時間を表す｢年柱｣｢月柱｣｢日柱｣｢時柱｣という4つの柱からなる、｢命式｣という表を元に、宿命や運勢を占います。',
    thumbnail: '/static/img/fortunes/icons/icon_sityusuimei.svg'
  },
  id204: {
    tagId: 204,
    label: '風水',
    description: '数千年前の古代中国で生まれた、開運のための環境学。人間は置かれた環境によって運が左右されるという思想にのっとり、国家や城を築く際に最適な土地の選択、軍備の配置方法などに使われてきました。',
    thumbnail: '/static/img/fortunes/icons/icon_husui.svg'
  },
  id205: {
    tagId: 205,
    label: '算命学',
    description: '東洋占いの代表的な占術の1つ。陰陽五行説をもとに、生年月日から、その人の性格や運命を導き出していく占いです。「天中殺」の考え方が特徴的。',
    thumbnail: '/static/img/fortunes/icons/icon_sanmeigaku.svg'
  },
  id206: {
    tagId: 206,
    label: '九星気学',
    description: '生年月日の九星と干支、五行を組み合わせて、性質や運勢を導いていく占いです。吉凶を占うことや、大きな流れの運勢を読んでいくことを得意とします。',
    thumbnail: '/static/img/fortunes/icons/icon_kyuseikigaku.svg'
  },
  id207: {
    tagId: 207,
    label: '易',
    description: '50本の筮竹(ぜいちく)を使って占う方法です。自然や人間を支配する8個の大切な要素「光、沢、火、雷、風、水、山、地」表す「八卦」をかけ合わせ、64個の卦を導き出して占います。',
    thumbnail: '/static/img/fortunes/icons/icon_eki.svg'
  },
  id208: {
    tagId: 208,
    label: '姓名判断',
    description: '姓名から、性格や運勢を占っていく占術。一般的には姓名の画数より、5つの格数を導き出し、解釈していきます。総合的な運勢の吉凶を見ていくのに適している占いだと言えるでしょう。',
    thumbnail: '/static/img/fortunes/icons/icon_seimeihandan.svg'
  },
  id209: {
    tagId: 209,
    label: '0学',
    description: '西洋、東洋の様々な占術を元にして作られた占術。時期を占うのに特に適しています。国に認可・登録された実績を有する、権威ある運命分析学です。',
    thumbnail: '/static/img/fortunes/icons/icon_zerogaku.svg'
  },
  id210: {
    tagId: 210,
    label: '宿曜',
    description: '宿曜占星術とも呼ばれる東洋古代の占星術。生まれたその日の月の位置より運勢を割り出します。27宿で、性格や才能、気になる人との相性まで、あらゆる関係を占うことができます。 ',
    thumbnail: '/static/img/fortunes/icons/icon_syukuyo.svg'
  },
  id211: {
    tagId: 211,
    label: '数秘術',
    description: '「万物の根源は数である」すべての数字には意味があるとする哲学者ピタゴラスの考えにより生まれた占術。生年月日や姓名の持つ数字から、運勢や人生を解き明かします。',
    thumbnail: '/static/img/fortunes/icons/icon_suhijutsu.svg'
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/FORTUNE_INFO.js